import message from '../../components/Message/Message';
import sleep from '../services/Sleep';
import createElement from './createElement';
import htmlToElement from './htmlToElement';

export type actionType =
  | {
      type: 'message';
      text: string;
      level: string;
    }
  | {
      type: 'redirect';
      delay: number;
      link: string;
    }
  | {
      type: 'formError';
      properties: {
        [key: string]: {
          errors: string[];
        };
      };
    }
  | {
      type: 'connection';
      title: string;
      message: {
        type: 'message';
        text: string;
        level: string;
      };
    };

export default function actionsResponse(
  actions: actionType[],
  disableMessageTemplate = false,
  separatorMessages = '',
  dataResponse: Record<string, any> | null = null
) {
  if (!actions?.length) return '';
  const messages: string[] = [];
  const resolvedData = dataResponse || {};

  actions.forEach(async (action) => {
    switch (action.type) {
      case 'message': {
        if (disableMessageTemplate) {
          messages.push(action.text);
        } else {
          messages.push(
            message({
              messageContent: action.text,
              level: action.level,
            })
          );
        }
        break;
      }
      case 'redirect': {
        await sleep(action.delay);
        if (action.link.endsWith('/cart') && resolvedData) {
          let currentLineCart: any;
          const hostUrl =
            document.querySelector<HTMLInputElement>('#host_url').value ?? '/';
          const dataCartDiff = resolvedData.cartDiff;
          const dataCart = resolvedData.cart;
          if (
            dataCartDiff?.alert &&
            Array.isArray(dataCartDiff.items) &&
            dataCartDiff.items.length > 0
          ) {
            const [firstItem] = dataCartDiff.items;
            currentLineCart = firstItem;
          }

          const alertData = {
            currentLineCart,
            hostUrl,
            dataCart,
          };

          localStorage.setItem('alertStockData', JSON.stringify(alertData));
        }
        window.location.href = action.link;
        break;
      }
      case 'formError': {
        Object.entries(action.properties).forEach(([key, { errors }]) => {
          const input = document.querySelector(
            `[name="${key}"]:not([type="hidden"])`
          );
          if (!input) return;

          const inputGroup = input.closest('.c-form__group');
          if (!inputGroup) return;

          inputGroup.classList.add('c-form__isInvalid');
          const invalidMessageElement = createElement(
            'span',
            {
              class: 'c-form__invalidFeedback',
            },
            errors.join(', ')
          );
          inputGroup.append(invalidMessageElement);

          // Adding event listener to remove error message on input change
          const removeErrorMessage = () => {
            inputGroup.classList.remove('c-form__isInvalid');
            invalidMessageElement.remove();
            input.removeEventListener('input', removeErrorMessage);
          };

          input.addEventListener(
            input.tagName === 'INPUT' ? 'input' : 'change',
            removeErrorMessage
          );
        });
        break;
      }
      case 'connection': {
        const connectionElement: HTMLButtonElement = document.querySelector(
          '.js-openModalConnection'
        );

        if (connectionElement) {
          const bodyElement = document.querySelector<HTMLElement>('body');
          connectionElement.click();

          if (!bodyElement.classList.contains('js-connectionOpen--processed')) {
            bodyElement.classList.add('js-connectionOpen--processed');

            // Open modal connection & update title & message
            connectionElement.addEventListener(
              'modal:connection:open',
              ({ detail }: CustomEvent) => {
                const formElement = document.querySelector<HTMLFormElement>(
                  '#c-cart__promotionCodePanelForm'
                );

                if (formElement.classList.contains('js-submitConnection')) {
                  const modal = detail.modalElement as HTMLElement;
                  formElement.classList.remove('js-submitConnection');
                  if (!modal) return;

                  const modalTitle = modal.querySelector<HTMLInputElement>(
                    '.c-modal__header .c-modal__title'
                  );
                  if (!modalTitle) return;
                  modalTitle.textContent = action.title;

                  const modalContentTitle =
                    modal.querySelector<HTMLInputElement>(
                      '.c-modalConnectionTitle'
                    );
                  if (!modalContentTitle) return;
                  modalContentTitle.before(
                    htmlToElement(
                      message({
                        messageContent: action.message.text,
                        level: action.message.level,
                      })
                    )
                  );
                }
              }
            );
          }
        }
        break;
      }
      default:
        break;
    }
  });

  return messages.join(separatorMessages);
}
